import React, { useState, useEffect } from "react";
import { Box, Typography, Avatar, IconButton } from "@mui/material";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import AOS from "aos";
import "aos/dist/aos.css";

const testimonials = [
  {
    id: 1,
    quote:
      "I've been using Products for over a year now, and it's been a game-changer. The quality is top-notch, and it saves me so much time!",
    name: "Ziyad",
    email: "ziyad11@gmail.com",
    image: "https://via.placeholder.com/48", // Replace with actual image URL
  },
  {
    id: 2,
    quote:
      "The service is outstanding, and I couldn't be happier. It's exactly what I needed for my business!",
    name: "Amira",
    email: "amira22@gmail.com",
    image: "https://via.placeholder.com/48", // Replace with actual image URL
  },
  {
    id: 3,
    quote:
      "Absolutely love this! It makes my workflow seamless and efficient. Highly recommended!",
    name: "Noah",
    email: "noah33@gmail.com",
    image: "https://via.placeholder.com/48", // Replace with actual image URL
  },
];

const TestimonialsSlider = () => {
  const [currentIndex, setCurrentIndex] = useState(0);

  const handleNext = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % testimonials.length);
  };

  const handlePrev = () => {
    setCurrentIndex(
      (prevIndex) => (prevIndex - 1 + testimonials.length) % testimonials.length
    );
  };

  useEffect(() => {
    AOS.init({
      duration: 1000, // Duration of animations
      easing: 'ease-in-out', // Easing of animations
      once: true, // Run animation only once
    });

    // Set up auto-sliding
    const interval = setInterval(handleNext, 3000); // Change every 5 seconds

    // Clear the interval when the component unmounts
    return () => clearInterval(interval);
  }, []);

  return (
    <Box
      sx={{
        textAlign: "center",
        padding: "2rem",
        backgroundColor: "#f9f9f9",
        borderRadius: "12px",
      }}
    >
      {/* Section Title */}
      <Typography variant="h6" color="green" fontWeight="bold" sx={{fontFamily: '"Montserrat", sans-serif',}}>
        Testimonials
      </Typography>
      <Typography variant="h4" sx={{fontFamily: '"Montserrat", sans-serif',}} fontWeight="bold" color="#A9C47F" mt={1}>
        Our Trusted Clients
      </Typography>

      {/* Carousel */}
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          position: "relative",
          marginTop: "2rem",
        }}
      >
        {/* Left Arrow */}
        <IconButton
          onClick={handlePrev}
          sx={{ position: "absolute", left: "10px" }}
        >
          <ArrowBackIosIcon />
        </IconButton>

        {/* Testimonial Card */}
        <Box
          sx={{
            width: "300px",
            height: "250px",
            borderRadius: "16px",
            backgroundColor: "#F5F5F5",
            boxShadow: "0 4px 10px rgba(0, 0, 0, 0.1)",
            padding: "1.5rem",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            textAlign: "center",
            position: "relative",
            transition: "all 0.5s ease-in-out",
          }}
          data-aos="fade-up" // Apply fade-up animation
        >
          <Typography
            variant="body1"
            sx={{
              fontStyle: "italic",
              marginBottom: "1rem",
              fontSize: "1rem",
              lineHeight: "1.5",
            }}
          >
            "{testimonials[currentIndex].quote}"
          </Typography>
          <Avatar
            src={testimonials[currentIndex].image}
            alt={testimonials[currentIndex].name}
            sx={{ width: 48, height: 48, marginBottom: "0.5rem" }}
          />
          <Typography fontWeight="bold">
            {testimonials[currentIndex].name}
          </Typography>
          <Typography variant="body2" color="gray">
            {testimonials[currentIndex].email}
          </Typography>
        </Box>

        {/* Right Arrow */}
        <IconButton
          onClick={handleNext}
          sx={{ position: "absolute", right: "10px" }}
        >
          <ArrowForwardIosIcon />
        </IconButton>
      </Box>
    </Box>
  );
};

export default TestimonialsSlider;
